async function handleJson(url: string) {
  return fetch(url).then((res) => res.json())
}

export interface IResponse {
  statusCode: number
  message: any
  error?: string
}

const Headers = {
  normal: async () => {
    return { headers: { 'Content-Type': 'application/json' } }
  },
  key: async () => {
    const session = localStorage.getItem('token')
    return {
      headers: { Authorization: `Bearer ${session}`, 'Content-Type': 'application/json' },
    }
  },
  file: async () => {
    const session = localStorage.getItem('token')
    return {
      headers: { Authorization: `Bearer ${session}`, 'Content-Type': 'multipart/form-data' },
    }
  },
}

export { Headers, handleJson } 